import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await authAPI.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send reset email');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-vh-100 d-flex align-items-center" style={{ backgroundColor: 'var(--light-bg)' }}>
        {/* Navbar */}
        <nav className="navbar navbar-light bg-white shadow-sm position-fixed top-0 w-100" style={{ zIndex: 1000 }}>
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img src="/images/lensverse_logo.png" alt="LensVerse Logo" style={{ height: '40px', width: 'auto' }} />
              <span>LensVerse</span>
            </Link>
          </div>
        </nav>

        <div className="container py-5" style={{ marginTop: '60px' }}>
          <div className="row justify-content-center">
            <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4 p-md-5 text-center">
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{ width: '56px', height: '56px', background: 'var(--gradient-success)' }}
                  >
                    <i className="fas fa-check text-white fs-5"></i>
                  </div>
                  <h5 className="fw-semibold mb-3" style={{ color: 'var(--primary-color)' }}>
                    Check your email
                  </h5>
                  <p className="text-muted mb-4">
                    We've sent a password reset OTP to <strong>{email}</strong>.
                    Please check your inbox and enter the code on the reset page.
                  </p>
                  <Link
                    to={`/reset-password?email=${encodeURIComponent(email)}`}
                    className="btn btn-primary"
                  >
                    <i className="fas fa-key me-2"></i>
                    Enter OTP Code
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 d-flex align-items-center" style={{ backgroundColor: 'var(--light-bg)' }}>
      {/* Navbar */}
      <nav className="navbar navbar-light bg-white shadow-sm position-fixed top-0 w-100" style={{ zIndex: 1000 }}>
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/lensverse_logo.png" alt="LensVerse Logo" style={{ height: '40px', width: 'auto' }} />
            <span>LensVerse</span>
          </Link>
        </div>
      </nav>

      <div className="container py-5" style={{ marginTop: '60px' }}>
        <div className="row justify-content-center">
          <div className="col-12 col-sm-10 col-md-8 col-lg-5 col-xl-4">
            <div className="card shadow-sm border-0 rounded-4">
              <div className="card-body p-4 p-md-5">
                <div className="text-center mb-4">
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{ width: '56px', height: '56px', background: 'var(--gradient-primary)' }}
                  >
                    <i className="fas fa-key text-white fs-5"></i>
                  </div>
                  <h5 className="fw-semibold mb-1" style={{ color: 'var(--primary-color)' }}>
                    Forgot your password?
                  </h5>
                  <p className="text-muted small">
                    Enter your email and we'll send you a reset code.
                  </p>
                </div>

                {error && (
                  <div className="alert alert-danger py-2 mb-3" role="alert">
                    <small>{error}</small>
                  </div>
                )}

                <form onSubmit={handleSubmit} noValidate>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      required
                    />
                  </div>

                  <div className="d-grid mb-3">
                    <button
                      type="submit"
                      className="btn btn-primary py-2 fw-semibold"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-paper-plane me-2"></i>
                          Send Reset Code
                        </>
                      )}
                    </button>
                  </div>

                  <div className="text-center">
                    <Link to="/login" className="text-decoration-none small">
                      <i className="fas fa-arrow-left me-1"></i>
                      Back to sign in
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
